"use client"

import { create } from "zustand"

export interface FloatingChatCompanion {
  id: string
  name: string
  avatarUrl: string | null
  avatarFocalX?: number
  avatarFocalY?: number
  introduction: string | null
  booruTags?: string[]
}

interface FloatingChatState {
  companion: FloatingChatCompanion | null
  sessionId: string | null
  minimized: boolean

  /** Pins a companion's session to the floating bubble so it follows the
   * user across the app. Always starts minimized — the point is to be
   * unobtrusive until explicitly expanded. */
  activate: (companion: FloatingChatCompanion, sessionId: string) => void

  /** Fully dismisses the bubble. It will not reappear until activate() is
   * called again from a chat screen. */
  deactivate: () => void

  setMinimized: (minimized: boolean) => void
}

export const useFloatingChatStore = create<FloatingChatState>((set) => ({
  companion: null,
  sessionId: null,
  minimized: true,

  activate: (companion, sessionId) => set({ companion, sessionId, minimized: true }),
  deactivate: () => set({ companion: null, sessionId: null }),
  setMinimized: (minimized) => set({ minimized }),
}))
